import React from "react";
import { useAuth } from "@/lib/auth";
import { EagleLogo } from "@/components/EagleLogo";

export default function AccessPending() {
    const { user, logout } = useAuth();
    return (
        <div className="min-h-screen flex items-center justify-center paper-bg" data-testid="access-pending">
            <div className="bg-white rounded-2xl border border-brand-charcoal/15 shadow-card p-8 max-w-md text-center">
                <EagleLogo className="h-12 w-12 mx-auto" color="#3A2418" />
                <h2 className="font-bold text-2xl mt-3 text-brand-charcoal">Access pending</h2>
                <p className="text-sm text-brand-charcoal/70 mt-3">
                    You're signed in as <span className="font-semibold">{user?.email}</span>, but no employee record is set up for this email yet.
                </p>
                <p className="text-sm text-brand-charcoal/70 mt-2">Ask your admin to add you, then come back and refresh.</p>
                <button onClick={logout} className="mt-6 h-12 px-6 bg-brand-navy hover:bg-brand-navy-dark text-brand-bone rounded-xl font-semibold" data-testid="access-pending-signout">
                    Sign out
                </button>
            </div>
        </div>
    );
}
